import React, {useMemo} from 'react';
import styles from "./styles.module.scss";
import Image from "next/image";
import ceoMobile from "/public/aboutUs/ceoMobile.png";
import ceoDesc from "/public/aboutUs/ceoDesc.png";
import useTranslation from "next-translate/useTranslation";
import {ABOUT_NAMESPACE} from "../../../../utils/i18nNameSpaces";

const Index = () => {
  const {t} = useTranslation(ABOUT_NAMESPACE);

  const list = [
    "_1",
    "_2",
    "_3",
    "_4",
    "_5",
    "_6",
  ]

  const stories = useMemo(() => {
    return (
      <ul className={styles["story-list"]}>
        <li className={styles["ceo-item"]}>
          <div className={styles["ceo-wrapper"]}>
            <span className={styles["ceo-header"]}>{t("ceo.header")}</span>
            <div className={styles["ceo"]}>
              <div className={styles["ceo-img"]}>
                <Image src={ceoDesc} quality={100} layout={"responsive"}/>
              </div>
              <div className={styles["ceo-img--mobile"]}>
                <Image src={ceoMobile} quality={100} layout={"responsive"}/>
              </div>
              <div className={styles["ceo-info"]}>
                <span className={styles["ceo-name"]}>{t("ceo.name")}</span>
                <span className={styles["ceo-job"]}>{t("ceo.job")}</span>
              </div>
            </div>
          </div>
        </li>
        {list.map((el, i) => (
          <li key={i} className={styles["list-item"]}>
            <h4 className={styles["story-header"]}>{t(`story.${el}.header`)}</h4>
            <p className={styles["story-text"]}>{t(`story.${el}.text`)}</p>
          </li>
        ))}
      </ul>
    )
  },[t])

  return (
    <section className={styles["story"]}>
      <div className={styles["container"]}>
        <div>
          {stories}
         <div className={styles["last"]}>
           <h4 className={styles["story-header"]}>{t(`story._${list.length + 1}.header`)}</h4>
           <p className={styles["story-text"]}>{t(`story._${list.length + 1}.text`)}</p>
         </div>
        </div>
      </div>
    </section>
  );
};

export default Index;